export const CONTRACT_TYPE = {
  ERC721: 1,
  ERC20: 2,
  ERC1155: 3,
};

export const CSV_REQUEST_SIZE = 100;
